import React from "react";
import logo from "./../../../assets/images/logo.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import BookIcon from "@mui/icons-material/Book";
import HistoryIcon from "@mui/icons-material/History";
import ForumIcon from "@mui/icons-material/Forum";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IoLogOutSharp } from "react-icons/io5";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import GroupIcon from "@mui/icons-material/Group";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import GroupsIcon from '@mui/icons-material/Groups';
const SideMenuData = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let CurrentPagePath = location.pathname;
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const isMatch = useMediaQuery(theme.breakpoints.down("lg"));
  return (
    <>
      {isMatch ? (
        <div></div>
      ) : (
        <div
          className="tutor-panel-sider-container"
          style={{ position: isMatch ? "" : "fixed" }}
        >
          <div className="tutor-panel-sider-content-wraper">
            <div className="tutor-panel-sider-logo-container">
              <img src={logo} alt="logo" width="100px" />
            </div>
            <div className="side-menu-data-list-main">
              <ul className="side-menu-ul">
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/dashboard"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/dashboard");
                    }}
                  >
                    <DashboardIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">dashboard</span>
                  </Button>
                </li>

                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/my-profile"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/my-profile");
                    }}
                  >
                    <PersonIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">my profile</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/my-courses" ||
                      CurrentPagePath === "/student-panel/my-courses/view" ||
                      CurrentPagePath === "/student-panel/my-courses/live"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/my-courses");
                    }}
                  >
                    <BookIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">my courses</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/courses-history" ||
                      CurrentPagePath === "/student-panel/courses-history/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/courses-history");
                    }}
                  >
                    <HistoryIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">
                      courses History
                    </span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/chat"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/chat");
                    }}
                  >
                    <ForumIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">chat</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/notifications" ||
                      CurrentPagePath === "/student-panel/notifications/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/notifications");
                    }}
                  >
                    <NotificationsActiveIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">notifications</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/my-wallet"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/my-wallet");
                    }}
                  >
                    <AccountBalanceWalletIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">my wallet</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/invoice" ||
                      CurrentPagePath === "/student-panel/invoice/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/invoice");
                    }}
                  >
                    <PriceChangeIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">invoice</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/invite-friends"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/invite-friends");
                    }}
                  >
                    <GroupIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">invite friends</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/dispute" ||
                      CurrentPagePath === "/student-panel/dispute/create"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/dispute");
                    }}
                  >
                    <PsychologyIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">dispute</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/assignment" ||
                      CurrentPagePath === "/student-panel/assignment/view" ||
                      CurrentPagePath === "/student-panel/assignment/create"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/assignment");
                    }}
                  >
                    <AssignmentIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Assignment</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/attendance" 
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/attendance");
                    }}
                  >
                    <GroupsIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">attendance</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/result" ||
                      CurrentPagePath === "/student-panel/result/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/result");
                    }}
                  >
                    <FactCheckIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">result</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/leave-request" ||
                      CurrentPagePath ===
                        "/student-panel/leave-request/create" ||
                      CurrentPagePath === "/student-panel/leave-request/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/leave-request");
                    }}
                  >
                    <LiveHelpIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">leave request</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/student-panel/transaction-history"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/student-panel/transaction-history");
                    }}
                  >
                    <PointOfSaleIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">
                      transaction history
                    </span>
                  </Button>
                </li>
                <br />
              </ul>
            </div>
            <div className="first-tutor-panel-sider-log-out-container">
              <Button
                variant="text"
                className="logout-button"
                onClick={() => {
                  navigate("/");
                  window.location.reload();
                }}
              >
                <span>Logout</span>
                <IoLogOutSharp className="side-menu-icon" />
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default SideMenuData;
